import React, { useState } from 'react';
import './TopWidgetEdit.css';
import SaveTemplatePopup from '../WidgetEditComponents/SaveTemplatePopup';

/**
 * 🎨 HERO HEADER EDIT NEO
 * 
 * Minimale Komponente die NUR den "Save as Template" Button enthält
 */
function HeroHeaderEditNEO({ widget, onUpdate, colors }) {
    // ✅ SAVE TEMPLATE POPUP STATE
    const [showSaveTemplatePopup, setShowSaveTemplatePopup] = useState(false);

    return (
        <div>
            <div className="top-widget-edit-container">
                
                {/* 💾 SAVE AS TEMPLATE BUTTON */}
                <div className="save-template-section">
                    <button 
                        className="save-template-btn"
                        onClick={() => setShowSaveTemplatePopup(true)}
                        title="Save this widget configuration as a reusable template"
                    >
                        <i className="fas fa-save"></i>
                        Save as Template
                    </button>
                </div>

                {/* 💾 SAVE TEMPLATE POPUP */}
                <SaveTemplatePopup
                    isOpen={showSaveTemplatePopup}
                    onClose={() => setShowSaveTemplatePopup(false)}
                    widgetData={widget}
                    originalWidgetType={widget.type}
                    colors={colors}
                />
                
            </div>
        </div>
    );
}

export default HeroHeaderEditNEO;
